import { Boolean, Literal, Null, Number, Record, String } from 'runtypes';

const MailInvitationParticipationRunType = Literal('ACCEPTED').Or(Literal('TENTATIVE')).Or(Literal('DECLINED'));
const MailInvitationMatchingAttendeeRunType = Record({
	address: String,
	partstat: String.Or(Null),
	rsvp: Boolean,
});
const MailInvitationOrganizerRunType = Record({
	address: String,
	name: String.Or(Null),
});

const InvitationFactsRunType = Record({
	aggregateId: String,
	allDay: Boolean,
	currentResponse: MailInvitationParticipationRunType.Or(Null),
	description: String.Or(Null),
	endDate: String.Or(Null),
	filename: String,
	ineligibilityReason: String.Or(Null),
	invitationId: Number,
	location: String.Or(Null),
	mailId: Number,
	matchingAttendee: MailInvitationMatchingAttendeeRunType.Or(Null),
	method: String.Or(Null),
	organizer: MailInvitationOrganizerRunType.Or(Null),
	receivingMailAccountId: Number.Or(Null),
	respondable: Boolean,
	responseAlreadySent: Boolean,
	sequence: Number.Or(Null),
	startDate: String.Or(Null),
	suggestedSendingAccountId: Number.Or(Null),
	summary: String.Or(Null),
	uid: String.Or(Null),
});

export const MailInvitationQueryWrapperRunType = Record({
	invitation: InvitationFactsRunType.Or(Null),
});
